package hk.com.vr360_demo2.webapp.component.viewer.component

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.*

external interface NameCodeViewProps : Props {
    var name: String?
    var code: String?
    var companyName: String?
    var showCompanyName: Boolean
}

val NameCodeView = FC<NameCodeViewProps> { props ->
    div {
        css {
            display =  Display.flex
            flexDirection =  FlexDirection.column
            marginLeft = 6.px
            maxWidth=140.px
            minWidth=100.px
            asDynamic().minWidth = "0"
            asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                maxWidth = 140.px
            }
        }
        div {
            css {
                fontWeight = FontWeight.bold
                color = NamedColor.white
                fontSize = 14.px
                overflow = Overflow.hidden
                textOverflow = TextOverflow.ellipsis
                maxWidth = 140.px
            }
            +(props.name ?: "")
        }
        div {
            css {
                fontSize = 12.px
                color = NamedColor.white
                whiteSpace = WhiteSpace.nowrap
                overflow = Overflow.hidden
                textOverflow = TextOverflow.ellipsis
                maxWidth = 140.px
            }
            +(props.code ?: "")
        }
        if (props.showCompanyName && !props.companyName.isNullOrBlank()) {
            div {
                css {
                    fontSize = 12.px
                    color = NamedColor.white
                    whiteSpace = WhiteSpace.nowrap
                    overflow = Overflow.hidden
                    textOverflow = TextOverflow.ellipsis
                    maxWidth = 140.px
                }
                +(props.companyName ?: "")
            }
        }
    }
}

